import _ from 'lodash';

const editorState = {
  editorMode: '',
  poppers: {},
  scrollbars: {},
  user: {},
  tooltips: [],
  history: [],
  currentHistoryIndex: -1,
  undoInProgress: false,
  redoInProgress: false,
  totalChangesSinceLastSave: 0,
  filtersCache: {},
  keyboardCtrlDown: false,
  keyboardShiftDown: false,
  isChangingPage: false,
  deletingPage: false,
  cropElementCacheKey: '',
  pages: [],
  currentPageIndex: 0,
  sidebarCurrentImagesTag: '',
  sidebarCurrentImagesTagItem: '',
  sidebarCurrentQuotesCategory: '',
  sidebarCurrentBackgroundsTag: '',
  sidebarCurrentBackgroundsFormat: '',
  itWasOverMagicFrame: undefined,
  isDragging: false,
  isErasing: false,
  isFocusingOnInput: false,
  isLoading: {
    canvas: false,
  },
  eraserRadius: 25, // 1 - 50
  cloneStampBrushRadius: 60,
  cloneStampBrushAlpha: 1,
  cloneStampBrushHardness: 0.5,
  rulerEnabled: false,
};

const stateObservables = {};

export const subscribeToStateChange = async (
  statePropertyNames = [],
  observerFunction,
  runImmediatelyOnSubscribe = false
) => {
  if (
    !statePropertyNames ||
    !statePropertyNames.length ||
    !observerFunction ||
    !stateObservables
  ) {
    throw new Error('Cannot subscribeToStateChange: Missing configuration.');
  }

  for (const statePropertyName of statePropertyNames) {
    if (!stateObservables[statePropertyName]) {
      stateObservables[statePropertyName] = [];
    }

    stateObservables[statePropertyName].push(observerFunction);

    if (runImmediatelyOnSubscribe) {
      await observerFunction(editorState[statePropertyName]);
    }
  }
};

export const runObserverSubscriptions = async (statePropertyName) => {
  if (!statePropertyName) {
    throw new Error(
      'Cannot runObserverSubscriptions: Missing statePropertyName.'
    );
  }

  const observers = stateObservables[statePropertyName] || [];

  for (let observer of observers) {
    await observer(editorState[statePropertyName]);
  }
};

export const unsetState = async (statePropertyName) => {
  delete editorState[statePropertyName];
  await runObserverSubscriptions(statePropertyName);
};

export const modifyState = async (statePropertyName, newStatePropertyValue) => {
  _.set(editorState, statePropertyName, newStatePropertyValue);
  await runObserverSubscriptions(statePropertyName);
};

export const incrementState = async (statePropertyName) => {
  const currentValue = _.get(editorState, statePropertyName, 0);
  const nextValue = currentValue + 1;
  _.set(editorState, statePropertyName, nextValue);
  await runObserverSubscriptions(statePropertyName);
};

export const decrementState = async (statePropertyName) => {
  const currentValue = _.get(editorState, statePropertyName, 0);
  const nextValue = currentValue - 1;
  _.set(editorState, statePropertyName, nextValue);
  await runObserverSubscriptions(statePropertyName);
};

export const toggleState = async (statePropertyName, defaultValueIfMissing) => {
  const currentValue = _.get(
    editorState,
    statePropertyName,
    defaultValueIfMissing
  );
  const nextValue = !currentValue;
  editorState[statePropertyName] = nextValue;
  await runObserverSubscriptions(statePropertyName);
};

export const getState = (statePropertyPath, defaultValueIfMissing) => {
  const value = _.get(editorState, statePropertyPath);

  if (_.isEmpty(value) && defaultValueIfMissing) {
    return defaultValueIfMissing;
  }

  return value;
};

export const getStatePure = (statePropertyPath, defaultValueIfMissing) => {
  const value = _.get(editorState, statePropertyPath);

  if (_.isEmpty(value) && defaultValueIfMissing) {
    return defaultValueIfMissing;
  }

  return _.clone(value);
};

window.debugState = (property, returnValue = false, type = 'table') => {
  if (property) {
    if (type === 'table') {
      console.table(_.get(editorState, property));
    } else {
      console.log(_.get(editorState, property));
    }
    if (returnValue) {
      return _.get(editorState, property);
    }
  }
  console.table(editorState);

  if (returnValue) {
    return editorState;
  }
};

window.debugObservables = () => {
  console.table(stateObservables);
};
export default editorState;
